import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyHoldLinearIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M3.5 21C3.224 21 3 20.776 3 20.5V3.5C3 3.224 3.224 3 3.5 3H11.825C11.951 3 12.073 3.048 12.165 3.134L21.355 11.676C21.451 11.765 21.499 11.883 21.499 12C21.499 12.117 21.451 12.234 21.355 12.324L12.165 20.866C12.072 20.952 11.951 21 11.825 21H3.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyHoldLinearIcon.displayName = 'TimeDkeyHoldLinearIcon';
